import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTSlideTransition } from '@tencent/slide-sdk-pb-model';
import {
    getTransitionModelByType,
    Transition,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model-factory';
import {
    getTransitionConverterByType,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-converter-factory';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { ITransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/interface';

// 非动画类型的动画属性key
const sdkPropertyKeys = ['dur', 'spd', 'sndAc', 'extLst', 'advClick', 'advTm'];
const uiPropertyKeys = ['duration', 'speed', 'advanceOnClick', 'advanceAfterTime'];

export class TransitionPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(sdkData: DeepReadonly<ICTSlideTransition>):
        ITransitionModel | undefined {
        const type = this.getTransitionType(sdkData);
        let uiDataModel = getTransitionModelByType(type);
        const converter = getTransitionConverterByType(type);

        converter.convertPartialSdkToUi(sdkData, uiDataModel);

        // 特殊降级为无切换
        // 用于处理不支持的特殊case，如office中有：type一样，但不同options对应不同效果，部分目前支持的还不完善
        // 这里进行一些特殊判断来降级这类情况
        if (!uiDataModel.isSupported) {
            uiDataModel = this.createEmptyModel(sdkData);
        }

        uiDataModel.initProperty();

        return uiDataModel;
    }

    public static convertPartialDataFromUiToSdk(uiData: DeepPartial<Transition>): DeepPartial<ICTSlideTransition> {
        const sdkData: DeepPartial<ICTSlideTransition> = {};

        // 处理普通的变更
        const { type } = uiData;
        const converter = getTransitionConverterByType(type);
        converter.convertPartialUiToSdk(uiData, sdkData as ICTSlideTransition);

        // 当需要删除时，会有 { xxx: null } 的props，这里再支持以type为key的解析
        const typeList = this.getAllTransitionType(uiData as any);
        if (typeList.length > 0) {
            typeList.forEach((type) => {
                if (!uiData[type]) {
                    (sdkData as any)[type] = null;
                } else {
                    const converter = getTransitionConverterByType(type);
                    converter.convertPartialUiToSdk(uiData, sdkData as ICTSlideTransition);
                }
            });
        }

        return sdkData;
    }

    private static createEmptyModel(sdkData: DeepReadonly<ICTSlideTransition>) {
        const uiDataModel = getTransitionModelByType();
        const converter = getTransitionConverterByType();

        converter.convertPartialSdkToUi(sdkData, uiDataModel);

        return uiDataModel;
    }

    private static getTransitionType(sdkData: DeepReadonly<DeepPartial<ICTSlideTransition>>):
        TransitionType | undefined {
        // sdk的transition数据结构为：{ push: {...}, dur: xx, spd: xx }，全部都混在一起
        // 所以这里直接以非动画属性的key作为transitionType
        return Object.keys(sdkData).find(key => !sdkPropertyKeys.includes(key)) as TransitionType;
    }

    private static getAllTransitionType(sdkData: DeepReadonly<DeepPartial<ICTSlideTransition>>): TransitionType[] {
        return Object.keys(sdkData).filter(key => !uiPropertyKeys.includes(key)) as TransitionType[];
    }
}
